module.exports = __webpack_public_path__ + "static/img/ios1.7f59fb5d.jpg";